<template>
  <router-view></router-view>
</template>

<script>
export default {
}
</script>

<style>
  @import './assets/main.css';
</style>
